import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import CameraIcon from "@atlaskit/icon/core/camera";
import EditIcon from "@atlaskit/icon/core/edit";
import PremiumIcon from "@atlaskit/icon/core/premium";
import VideoIcon from "@atlaskit/icon/core/video";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components/link/src/link";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";
import { tabbedHeroSectionVideoMessages } from "@/templates/home/home-page/src/sections-v2/reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type VideoContentTypeProps = TabProps;

export const VideoContentType: TabType = ({}: VideoContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/o5n375kcfv44lp12616c455j37582rcp.webp"
            imageAlt="This is an screenshot of a Loom video."
            title={intl.formatMessage(
                tabbedHeroSectionVideoMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionVideoMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionVideoMessages.contentFeaturePoint1
                    ),
                    icon: <VideoIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionVideoMessages.contentFeaturePoint2
                    ),
                    icon: <CameraIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionVideoMessages.contentFeaturePoint3
                    ),
                    icon: <EditIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionVideoMessages.contentFeaturePoint4
                    ),
                    icon: <PremiumIcon label="" />
                }
            ]}
            cta={
                // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                <Link
                    href={"/software/loom"}
                    text={intl.formatMessage(
                        tabbedHeroSectionVideoMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "loom",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Loom",
                        "data-track-event": "loom-pt.content-types.video.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "loom-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "loomCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "VideoContentType",
                                tab: "video",
                                userTeamType:
                                    user["extended_profile"]?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
